import * as React from "react";
import * as monaco from "monaco-editor";
import {
  BsFillExclamationCircleFill,
  BsFillExclamationTriangleFill,
  BsFillInfoCircleFill,
} from "react-icons/bs";
import style from "./style.module.css";

interface MarkerRowProps {
  filename: string;
  marker: monaco.editor.IMarkerData;
  onClick?: (marker: monaco.editor.IMarkerData) => void;
}

export function MarkerRow(props: MarkerRowProps) {
  const { filename, marker, onClick } = props;

  const handleClick = () => {
    if (onClick != null) {
      onClick(marker);
    }
  };

  let severity: JSX.Element | undefined;
  let severityClass:
    | "markerRowSeverityError"
    | "markerRowSeverityWarning"
    | "markerRowSeverityInfo" = "markerRowSeverityError";
  switch (marker.severity) {
    case monaco.MarkerSeverity.Error:
      severity = <BsFillExclamationCircleFill />;
      severityClass = "markerRowSeverityError";
      break;
    case monaco.MarkerSeverity.Warning:
      severity = <BsFillExclamationTriangleFill />;
      severityClass = "markerRowSeverityWarning";
      break;
    case monaco.MarkerSeverity.Info:
      severity = <BsFillInfoCircleFill />;
      severityClass = "markerRowSeverityInfo";
      break;
  }
  const splits = marker.message.split("\n");
  return (
    <div className={style.markerRow} onClick={handleClick}>
      <span className={style[severityClass]}>{severity}</span>
      <span className={style.markerRowFilename}>[{filename}]</span>
      <span className={style.markerRowMessage}>{splits[0]}</span>
      <span className={style.markerRowPosition}>
        {`(${marker.startLineNumber}, ${marker.startColumn})`}
      </span>
      <div style={{ marginLeft: 24 }}>
        {splits.slice(1).map((line, index) => {
          let spaceCount = 0;
          for (let i = 0; i < line.length; i++) {
            if (line.at(i) == " " || line.at(i) == "\t") {
              spaceCount++;
            } else {
              break;
            }
          }
          return (
            <div key={index} style={{ marginLeft: spaceCount * 8 }}>
              {line}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export interface MarkerRowsProps {
  filename?: string;
  markers?: monaco.editor.IMarkerData[];
  onClick?: (marker: monaco.editor.IMarkerData) => void;
}

export function MarkerRows(props: MarkerRowsProps) {
  const { filename, markers, onClick } = props;

  return (
    <div>
      {(markers ?? []).map((marker, i) => (
        <MarkerRow
          key={i}
          filename={filename ?? ""}
          marker={marker}
          onClick={onClick}
        />
      ))}
    </div>
  );
}
